import WinAmountController from '../../controllers/statusbar/WinAmountController';
import MainGridController from '../../controllers/grid/MainGridController';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { WinAmountViewGrid } from './WinAmountViewGrid';
import { COMPONENTS } from '../../lib/constants';
// import { COMPONENTS } from "../../lib/constants";

export const WinAmount = {
	name: COMPONENTS.WIN_AMOUNT,
	child: true,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: WinAmountController,
			name: 'WinAmountController',
			config: {
				item: 'WinAmount',
				val: 'WinAmount',
				win: 0,
				currency: GameConfigs.auth.balance.currency
			}
		},
		{
			Controller: MainGridController,
			name: 'WinAmountViewGrid',
			config: WinAmountViewGrid
		}
	],
	components: [
		{
			name: 'WinAmount',
			type: 'Sprite',
			components: [
				{
					name: 'WIN_LABEL',
					type: 'Text',
					position: {
						x: 0,
						y: 0
					},
					text: 'STATUS_BAR_WIN_LABEL'
				},
				{
					name: 'WIN_VALUE',
					type: 'Text',
					position: {
						x: 0,
						y: 0
					},
					text: 'STATUS_BAR_WIN_VALUE'
				}
			]
		}
	]
};
